import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from '../models/auth.models';
import { OtpSendResult } from '../models/registration.models';
import { ApiConfigService } from './api-config.service';

@Injectable({
  providedIn: 'root',
})
export class OtpService {
  constructor(
    private readonly http: HttpClient,
    private readonly apiConfig: ApiConfigService
  ) {}

  sendOtp(username: string, prefixCountry: string): Observable<OtpSendResult> {
    const url = this.apiConfig.buildUrl('INSCRIPTION', 'OTP', 'OTP_REQUEST');

    return this.http
      .post<ApiResponse<unknown>>(
        url,
        { username, prefix_country: prefixCountry },
        { observe: 'response' }
      )
      .pipe(
        map((response: HttpResponse<ApiResponse<unknown>>) => {
          if (response.status === 204) {
            return { status: 'OFF_SERVICE' as const };
          }

          const body = response.body;
          const status = (body?.status ?? 'ERROR') as OtpSendResult['status'];
          return { status, message: body?.message };
        })
      );
  }

  verifyOtp(username: string, code: string): Observable<ApiResponse<unknown>> {
    const url = this.apiConfig.buildUrl('INSCRIPTION', 'OTP', 'OTP_VERIFY');
    return this.http.post<ApiResponse<unknown>>(url, { username, code });
  }
}
